import React from "react"
import type { PaymentMethod } from "@stripe/stripe-js"
import type { StyleProps } from "@mallardbay/lib-react-components"
import {
    Button,
    HorizontalStack,
    useToast,
} from "@mallardbay/lib-react-components"

import useSetupIntentActions from "~utils/use-setup-intent-actions"
import StripePaymentElement from "~components/shared/stripe-payment-element"
import COPY from "~config/copy-constants"

interface Props {
    readonly onClose: () => void
    readonly onPaymentMethodAdded: (paymentMethod: PaymentMethod) => void
}

export default function PaymentElementForm({
    onClose: handleClose,
    onPaymentMethodAdded,
}: Props) {
    const styles = useStyles()

    const { showError } = useToast()

    const { createPaymentMethod, isLoadingCreate } = useSetupIntentActions({
        onPaymentMethodCreated: (paymentMethod) => {
            onPaymentMethodAdded(paymentMethod)
            handleClose()
        },
        onError: showError,
    })

    return (
        <>
            <StripePaymentElement id="payment-element" />
            <HorizontalStack style={styles.buttonsContainer}>
                <Button variant="ghost" onClick={handleClose}>
                    {COPY.CANCEL}
                </Button>
                <Button
                    onClick={createPaymentMethod}
                    isLoading={isLoadingCreate}
                >
                    {COPY.CONFIRM}
                </Button>
            </HorizontalStack>
        </>
    )
}

function useStyles() {
    const buttonsContainer: StyleProps = {
        marginTop: 6,
        justifyContent: "flex-end",
    }

    return { buttonsContainer }
}
